import { USER_SET_RECENT_SEARCHES } from "./actionTypes";
import { runSearchHistoryScript } from "api/scriptRequests";

export const getRecentSearches = () => async dispatch => {
  let res = await runSearchHistoryScript();
  dispatch({ type: USER_SET_RECENT_SEARCHES, payload: res });
};
